module.exports = __webpack_public_path__ + "static/media/Truss-Beverages-Terms-of-Use---Website---FR_June-2020.c79e3d31.pdf";